import { toast } from "react-toastify";
import usePaginator from "../../../../theme/Component/usePaginator";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { useEffect, useState } from "react";
import { _single, _UBLAdminFee, _UBLDispatcherContingency } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { InputDate } from "../../../../theme/Input/InputDate";

export const UBLDispatcherContingency = () => {

    const { instance, bean, setBean, lista, setLista, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_UBLDispatcherContingency);
    const paginator = usePaginator();

    const [date, setDate] = useState<string>(_single.getCurrenDate());
    const [regex, setRegex] = useState<string>("");

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar tipo de AIU", MODAL_SM);

    useEffect(() => {
        addRequiredFields(["Description", "FromDate", "UptoDate"]);
    }, [])

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
        }

        instance.getUBLDispatcherContingencyCatalog(date, regex, paginator.page, 15).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Tipos de AIU");
        });
    };

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Crear tipo de AIU");
    }

    const deleteItem = () => {
        instance.deleteUBLDispatcherContingency(bean.IDUBLDispatcherContingency).then(
            (resp) => {
                modalC.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        instance.updateUBLDispatcherContingency(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDUBLDispatcherContingency', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha de Inicio', property: 'FromDate', visible: true },
        { title: 'Fecha de Fin', property: 'UptoDate', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Tipo AIU ${bean.Name}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Períodos de Contingencia">
            <div className="row">
                <div className="col-md-6">
                    <label >Fecha</label>
                    <InputDate name="date" value={date} setDate={(e) => { setDate(e) }} />
                </div>
                <div className="col-md-6">
                    <label >Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                </div>
                <div className="col-md-6">
                    <BasicButton icon="ri-seach-line" useMargin eventClick={() => { getLista(); }}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        records={paginator}
                    />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('FromDate') ? 'has-error' : ''}`} >Fecha Inicio {isRequired('FromDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate label=" " name="" value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} withTime />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('UptoDate') ? 'has-error' : ''}`} >Fecha Fin {isRequired('UptoDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate label=" " name="" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} withTime />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('Description') ? 'has-error' : ''}`} >Descripción {isRequired('Description') ? <span className="text-danger">*</span> : ''}</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Description}</strong>
                    </ModalConfirm>

                </div>
            </div>
        </BasicPage>
    )
}